import React, { useState } from 'react';
import './Reservation.css';

const Reservation = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    date: '',
    guests: '',
    notes: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('预订成功！我们会尽快与您联系确认。');
    setFormData({
      name: '',
      phone: '',
      date: '',
      guests: '',
      notes: ''
    });
  };

  return (
    <section id="contact" className="reservation">
      <div className="reservation-bg">
        <img src="https://images.unsplash.com/photo-1562967960-f55495a8899b?w=1920&q=80" alt="面馆环境" />
        <div className="reservation-overlay"></div>
      </div>
      <div className="reservation-container">
        <div className="reservation-content">
          <div className="reservation-img">
            <img src="https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=500&q=80" alt="面道招牌面" />
          </div>
          <h2>预订座位</h2>
          <p>免排队等候，提前预订享受专属服务</p>
          <div className="contact-info">
            <div className="contact-item">
              <span className="contact-icon">📍</span>
              <span>北京市朝阳区建国路88号</span>
            </div>
            <div className="contact-item">
              <span className="contact-icon">📞</span>
              <span>010-8888-9999</span>
            </div>
            <div className="contact-item">
              <span className="contact-icon">🕐</span>
              <span>营业时间: 10:00 - 22:00</span>
            </div>
          </div>
        </div>
        <form className="reservation-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="您的姓名"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="tel"
              name="phone"
              placeholder="联系电话"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-row">
            <div className="form-group">
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <select
                name="guests"
                value={formData.guests}
                onChange={handleChange}
                required
              >
                <option value="" disabled>用餐人数</option>
                <option value="1">1人</option>
                <option value="2">2人</option>
                <option value="3-4">3-4人</option>
                <option value="5+">5人以上</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <textarea
              name="notes"
              placeholder="特殊要求（如：靠窗位置、庆生等）"
              value={formData.notes}
              onChange={handleChange}
            ></textarea>
          </div>
          <button type="submit" className="btn-submit">提交预订</button>
        </form>
      </div>
    </section>
  );
};

export default Reservation;
